import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getAdminById, defaultAdminData, updateAdmin, register } from '@/api/admins';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getRoles } from '@/api/roles';
import { getQuery } from '@/utils';
import { AdminModule } from '@/store/modules/admin';
import { getStates } from '@/api/locations/states';
import { getAgents } from '@/api/agents';
import { getBranches } from '@/api/locations/branches';
import { getAvailableDealers } from '@/api/dealers';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.roleList = [];
    this.adminToken = AdminModule;
    this.selectedRoles = [];
    this.changePassword = false;
    this.formData = Object.assign({}, defaultAdminData);
    this.loading = false;
    this.dealerOptions = [];
    this.selectedDealers = [];
    this.showDealerFilter = false;
    this.selectedStates = [];
    this.selectedBranches = [];
    this.selectedAgents = [];
    this.states = [];
    this.branches = [];
    this.agents = [];
    this.dealersLoading = false;
    this.filteringDealers = false;
    this.salesExecutiveRoleId = null;
    this.zonerManagerRoleId = null;
    this.currentAdminRoleSelected = null;
    this.previousAdminRoleSelected = [];
    this.filterParams = {};
    this.rules = {
      fullName: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 3,
        max: 100,
        message: 'Length should be 3 to 100',
        trigger: 'blur'
      }],
      mobileNumber: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        pattern: /^\d+$/,
        message: 'Please enter numbers only',
        trigger: 'blur'
      }, {
        min: 10,
        max: 10,
        message: 'Length should be 10',
        trigger: 'blur'
      }],
      emailAddress: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        type: 'email',
        message: 'Please enter correct email address',
        trigger: ['blur']
      }],
      password: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 6,
        message: 'Password length should be greater than 6',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return AppModule.language;
  }
  async activated() {
    await this.fetchRoles();
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      await this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultAdminData);
    }
    this.tempTagView = Object.assign({}, this.$route);
    // If sales executive or zonal manager role is selected on load, fetch dealers
    if (this.isSalesExecutiveSelected() || this.isZonalManagerSelected()) {
      this.fetchAvailableDealers();
    }
  }
  isSalesExecutiveSelected() {
    const salesExecutiveRole = this.roleList.find(role => role.name === 'Sales Executive');
    if (salesExecutiveRole) {
      this.salesExecutiveRoleId = salesExecutiveRole.id;
      this.currentAdminRoleSelected = 'Sales Executive';
      return this.selectedRoles.includes(salesExecutiveRole.id);
    }
    return false;
  }
  isZonalManagerSelected() {
    const zonerManagerRole = this.roleList.find(role => role.name === 'Zonal Manager');
    if (zonerManagerRole) {
      this.zonerManagerRoleId = zonerManagerRole.id;
      this.currentAdminRoleSelected = 'Zonal Manager';
      return this.selectedRoles.includes(zonerManagerRole.id);
    }
    return false;
  }
  isRoleDisabled(roleId) {
    const salesExecutiveRole = this.roleList.find(role => role.name === 'Sales Executive');
    const zonerManagerRole = this.roleList.find(role => role.name === 'Zonal Manager');
    if (salesExecutiveRole && this.selectedRoles.includes(salesExecutiveRole.id)) {
      return roleId !== salesExecutiveRole.id;
    }
    if (zonerManagerRole && this.selectedRoles.includes(zonerManagerRole.id)) {
      return roleId !== zonerManagerRole.id;
    }
    return false;
  }
  async fetchStates() {
    try {
      this.states = await getStates(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {
      console.error('Error fetching states:', error);
      this.$notify({
        title: 'Error',
        message: 'Failed to load states',
        type: 'error',
        duration: 2000
      });
    }
  }
  async fetchBranches() {
    try {
      this.branches = await getBranches(getQuery({
        enabled: true,
        sort: 'code,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {
      console.error('Error fetching branches:', error);
      this.$notify({
        title: 'Error',
        message: 'Failed to load branches',
        type: 'error',
        duration: 2000
      });
    }
  }
  async fetchAgents() {
    try {
      this.agents = await getAgents(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {
      console.error('Error fetching agents:', error);
      this.$notify({
        title: 'Error',
        message: 'Failed to load agents',
        type: 'error',
        duration: 2000
      });
    }
  }
  async fetchAvailableDealers() {
    if (!this.isSalesExecutiveSelected() && !this.isZonalManagerSelected()) {
      return;
    }
    try {
      this.dealersLoading = true;
      const adminId = this.isEdit ? this.formData.id : null;
      // Build query params
      const queryParams = {
        adminId: adminId,
        ...this.filterParams
      };
      if (this.currentAdminRoleSelected !== null) {
        queryParams.currentAdminRole = this.currentAdminRoleSelected;
      }
      console.log('query', queryParams);
      const dealers = await getAvailableDealers(queryParams);
      this.dealerOptions = dealers;
      console.log('dealers', this.dealerOptions);
      // If editing, check if dealers are already assigned
      if (this.isEdit && this.formData.dealers && this.formData.dealers.length) {
        this.selectedDealers = this.formData.dealers.map(dealer => dealer.id);
      }
    } catch (error) {
      console.error('Error fetching available dealers:', error);
      this.$notify({
        title: 'Error',
        message: 'Failed to load dealers',
        type: 'error',
        duration: 2000
      });
    } finally {
      this.dealersLoading = false;
    }
  }
  showDealerFilterModal() {
    // Load saved filters for the specific admin from localStorage
    const adminId = this.isEdit ? this.formData.id : 'new';
    const savedFilters = localStorage.getItem(`dealerFilters_${adminId}`);
    if (savedFilters) {
      const {
        stateIds,
        branchIds,
        agentIds
      } = JSON.parse(savedFilters);
      this.selectedStates = stateIds || [];
      this.selectedBranches = branchIds || [];
      this.selectedAgents = agentIds || [];
      this.filterParams = {
        stateIds: stateIds || undefined,
        branchIds: branchIds || undefined,
        agentIds: agentIds || undefined
      };
    } else {
      this.selectedStates = [];
      this.selectedBranches = [];
      this.selectedAgents = [];
      this.filterParams = {};
    }
    Promise.all([this.fetchStates(), this.fetchBranches(), this.fetchAgents()]).then(() => {
      this.showDealerFilter = true;
    });
  }
  cancelDealerFilters() {
    // Restore filters for the specific admin from localStorage or reset
    const adminId = this.isEdit ? this.formData.id : 'new';
    const savedFilters = localStorage.getItem(`dealerFilters_${adminId}`);
    if (savedFilters) {
      const {
        stateIds,
        branchIds,
        agentIds
      } = JSON.parse(savedFilters);
      this.selectedStates = stateIds || [];
      this.selectedBranches = branchIds || [];
      this.selectedAgents = agentIds || [];
    } else {
      this.selectedStates = [];
      this.selectedBranches = [];
      this.selectedAgents = [];
    }
    this.showDealerFilter = false;
  }
  async applyDealerFilters() {
    try {
      this.filteringDealers = true;
      // Update filter params
      this.filterParams = {
        stateIds: this.selectedStates.length > 0 ? this.selectedStates : undefined,
        branchIds: this.selectedBranches.length > 0 ? this.selectedBranches : undefined,
        agentIds: this.selectedAgents.length > 0 ? this.selectedAgents : undefined
      };
      // Save filters to localStorage for the specific admin
      const adminId = this.isEdit ? this.formData.id : 'new';
      localStorage.setItem(`dealerFilters_${adminId}`, JSON.stringify(this.filterParams));
      // Fetch dealers with filters
      await this.fetchAvailableDealers();
      // Auto-select dealers based on filter if any filter is applied
      const hasActiveFilters = this.selectedStates.length > 0 || this.selectedBranches.length > 0 || this.selectedAgents.length > 0;
      if (hasActiveFilters) {
        this.selectedDealers = this.dealerOptions.filter(dealer => !dealer.isAlreadyAssigned).map(dealer => dealer.id);
      }
      this.showDealerFilter = false;
    } catch (error) {
      console.error('Error applying dealer filters:', error);
      this.$notify({
        title: 'Error',
        message: 'Failed to apply dealer filters',
        type: 'error',
        duration: 2000
      });
    } finally {
      this.filteringDealers = false;
    }
  }
  handleRoleChange() {
    // Check if Sales Executive or Zonal Manager role is selected
    if (this.isSalesExecutiveSelected() || this.isZonalManagerSelected()) {
      // Clear other roles and fetch available dealers
      const selectedRoleId = this.isSalesExecutiveSelected() ? this.salesExecutiveRoleId : this.zonerManagerRoleId;
      this.selectedRoles = [selectedRoleId];
      this.selectedDealers = [];
      this.filterParams = {};
      // Clear localStorage for the specific admin when role changes
      const adminId = this.isEdit ? this.formData.id : 'new';
      localStorage.removeItem(`dealerFilters_${adminId}`);
      this.fetchAvailableDealers();
    } else {
      // Clear selected dealers if neither role is selected
      this.selectedDealers = [];
      this.dealerOptions = [];
      const adminId = this.isEdit ? this.formData.id : 'new';
      localStorage.removeItem(`dealerFilters_${adminId}`);
    }
  }
  async fetchData(id) {
    try {
      const data = await getAdminById(id);
      this.formData = data;
      // Populate selected roles
      if (data.adminsRole && data.adminsRole.length) {
        this.selectedRoles = data.adminsRole.map(adminRole => adminRole.id);
        this.previousAdminRoleSelected = [...this.selectedRoles];
      }
      // Set tagsview title
      const title = this.formData.emailAddress;
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
      // If this is a Sales Executive or Zonal Manager, get assigned dealers
      if (this.isSalesExecutiveSelected() || this.isZonalManagerSelected()) {
        this.fetchAvailableDealers();
      }
    } catch (err) {
      console.error('Error fetching admin details:', err);
      this.$notify({
        title: 'Error',
        message: 'Failed to load admin details',
        type: 'error',
        duration: 2000
      });
    }
  }
  async fetchRoles() {
    try {
      this.roleList = await getRoles(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (err) {
      console.error('Error fetching roles:', err);
    }
  }
  resetPassword() {
    if (!this.changePassword) {
      this.formData.password = '';
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    if (this.formData.id) {
      this.fetchData(this.formData.id);
    } else {
      this.$refs.formData.resetFields();
      this.selectedRoles = [];
      this.selectedDealers = [];
    }
  }
  async saveForm() {
    try {
      this.loading = true;
      // Prepare admin role data
      if (this.selectedRoles.length) {
        this.formData.adminsRole = this.selectedRoles.map(id => ({
          id
        }));
      }
      // Handle dealer assignments for Sales Executive or Zonal Manager
      if ((this.isSalesExecutiveSelected() || this.isZonalManagerSelected()) && this.selectedDealers.length) {
        this.formData.dealers = this.selectedDealers.map(id => ({
          id
        }));
      } else {
        this.formData.dealers = [];
      }
      let newAdminId;
      if (this.isEdit) {
        // Remove password if not changing
        if (!this.changePassword) {
          delete this.formData.password;
        }
        await updateAdmin(this.formData.id, this.formData);
      } else {
        const response = await register(this.formData);
        newAdminId = response.id; // Assuming the register API returns the new admin ID
      }
      // If new admin, rename the localStorage key
      if (!this.isEdit && newAdminId) {
        const savedFilters = localStorage.getItem('dealerFilters_new');
        if (savedFilters) {
          localStorage.setItem(`dealerFilters_${newAdminId}`, savedFilters);
          localStorage.removeItem('dealerFilters_new');
        }
      }
      this.$notify({
        title: 'Success',
        message: 'Admin saved successfully',
        type: 'success',
        duration: 2000
      });
      router.push('/admins/list');
    } catch (err) {
      console.error('Error saving admin:', err);
      this.$notify({
        title: 'Error',
        message: 'Failed to save admin',
        type: 'error',
        duration: 2000
      });
    } finally {
      this.loading = false;
    }
  }
  canChangePassword() {
    // Only allow password change in edit mode
    if (!this.isEdit) {
      return false;
    }
    // Allow super admin to change password
    if (this.adminToken.adminsRoleIds.includes(1)) {
      return true;
    }
    return false;
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'AdminDetail',
  components: {}
})], default_1);
export default default_1;